export enum TipoUpload{
   REGRA_SIMPLES,
   REGRA_COMPOSTA,
   ASSOCIACAO,
   GRUPO_CARTEIRA,
   ASSOCIACAO_GRUPO_CARTEIRA,
}
